import { render } from "./BlogHeader.vue?vue&type=template&id=390208a8"
import script from "./BlogHeader.vue?vue&type=script&lang=js"
export * from "./BlogHeader.vue?vue&type=script&lang=js"

import "./BlogHeader.vue?vue&type=style&index=0&id=390208a8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__